import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
import { Admin_API, DOCTOR_API, SUPRIVISOR_API } from '../../ApiNames';


export const fetchData1 = (open: any) => ({
    type: 'FETCH_DATA1_SUCCESS',
    payload: open,
});
export const fetchData2 = (urjent: any) => ({
    type: 'FETCH_DATA2_SUCCESS',
    payload: urjent,
}); export const fetchData3 = (close: any) => ({
    type: 'FETCH_DATA3_SUCCESS',
    payload: close,
});
export const fetchData4 = (appointments: any) => ({
    type: 'FETCH_DATA4_SUCCESS',
    payload: appointments,
});


export const fetchOpenCases = (uid: any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { q: 1, userid: uid };
            const apiname = DOCTOR_API.casesdoctor_API;
            const response = await LoginService.getData(apiname, payload);
            dispatch(fetchData1(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchUrjentCases = (uid: any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { q: 2, userid: uid };
            const apiname = DOCTOR_API.casesdoctor_API;
            const response = await LoginService.getData(apiname, payload);
            dispatch(fetchData2(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchCloseCases = (uid: any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { q: 3, userid: uid };
            const apiname = DOCTOR_API.casesdoctor_API;
            const response = await LoginService.getData(apiname, payload);
            dispatch(fetchData3(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchAppointments = (uid: any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { q: 4, userid: uid };
            const apiname = DOCTOR_API.casesdoctor_API;
            const response = await LoginService.getData(apiname, payload);
            dispatch(fetchData4(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

